import { cardTypes } from './lib/card-types';
import { addMatchingCardsToResults } from './lib/add-matching-cards-to-results';
import { isValidInputType } from './lib/is-valid-input-type';
import { isCardNumberValid } from './lib/is-valid-number';
import { findBestMatch } from './lib/find-best-match';
import { clone } from './lib/clone';
let customCards = {};
export const cardNames = {
    VISA: 'visa',
    MASTERCARD: 'mastercard',
    AMERICAN_EXPRESS: 'amex',
    DINERS_CLUB: 'dinersclub',
    DISCOVER: 'discover',
    DANKORT: 'dankort',
    JCB: 'jcb',
    UATP: 'uatp',
    UNIONPAY: 'unionpay',
    MAESTRO: 'maestro',
    ELO: 'elo',
    MIR: 'mir',
    HIPER: 'hiper',
    HIPERCARD: 'hipercard',
};
const ORIGINAL_TEST_ORDER = [
    cardNames.VISA,
    cardNames.MASTERCARD,
    cardNames.AMERICAN_EXPRESS,
    cardNames.DINERS_CLUB,
    cardNames.DISCOVER,
    cardNames.UATP,
    cardNames.JCB,
    cardNames.UNIONPAY,
    cardNames.MAESTRO,
    cardNames.DANKORT,
    cardNames.ELO,
    cardNames.HIPER,
    cardNames.HIPERCARD,
    cardNames.MIR,
];
let testOrder = clone(ORIGINAL_TEST_ORDER);
function findType(cardType) {
    return customCards[cardType] || cardTypes[cardType];
}
function getAllCardTypes() {
    return testOrder.map(cardType => clone(findType(cardType)));
}
function getCardPosition(name, ignoreErrorForNotExisting = false) {
    const position = testOrder.indexOf(name);
    if (!ignoreErrorForNotExisting && position === -1) {
        throw new Error(`"${name}" is not a supported card type.`);
    }
    return position;
}
export function creditCardType(cardNumber, guessBestMatch = true) {
    const results = [];
    if (!isValidInputType(cardNumber)) {
        return results;
    }
    if (cardNumber.length === 0) {
        return getAllCardTypes();
    }
    testOrder.forEach(cardType => {
        const cardConfiguration = findType(cardType);
        addMatchingCardsToResults(cardNumber, cardConfiguration, results);
    });
    const bestMatch = findBestMatch(results);
    if (guessBestMatch && bestMatch) {
        return [bestMatch];
    }
    return results;
}
creditCardType.getTypeInfo = (cardType) => clone(findType(cardType));
creditCardType.removeCard = (name) => {
    const position = getCardPosition(name);
    testOrder.splice(position, 1);
};
creditCardType.addCard = (config) => {
    const existingCardPosition = getCardPosition(config.type, true);
    customCards[config.type] = config;
    if (existingCardPosition === -1) {
        testOrder.push(config.type);
    }
};
creditCardType.updateCard = (cardType, updates) => {
    const originalObject = customCards[cardType] || cardTypes[cardType];
    if (!originalObject) {
        throw new Error(`"${cardType}" is not a recognized type. Use \`addCard\` instead.'`);
    }
    if (updates.type && originalObject.type !== updates.type) {
        throw new Error('Cannot overwrite type parameter.');
    }
    let clonedCard = clone(originalObject);
    clonedCard = Object.assign(Object.assign({}, clonedCard), updates);
    customCards[clonedCard.type] = clonedCard;
};
creditCardType.changeOrder = (name, position) => {
    const currentPosition = getCardPosition(name);
    testOrder.splice(currentPosition, 1);
    testOrder.splice(position, 0, name);
};
creditCardType.resetModifications = () => {
    testOrder = clone(ORIGINAL_TEST_ORDER);
    customCards = {};
};
creditCardType.isValid = (cardNumber, luhnCheck = true) => (luhnCheck ? isCardNumberValid(cardNumber) : true);
creditCardType.types = cardNames;
creditCardType.mask = (gaps, length) => {
    const maxlen = (Array.isArray(length)) ? Math.max(...length) : length;
    const mask = [...gaps, maxlen].map((el, idx, arr) => ((!idx) ? '0'.repeat(el) : '0'.repeat(el - arr[idx - 1])));
    return mask.join(' ');
};
//# sourceMappingURL=index.js.map